import { createGlobalStyle } from 'styled-components'
import { ThemeType } from './theme'

const font = 'AvenirLTStd-Black, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "DejaVu Sans", sans-serif'

export const GlobalStyle = createGlobalStyle<{ theme: ThemeType }>`
  * {
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
  }

  *:focus {
    outline: 0
  }

  @font-face {
    font-family: AvenirLTStd-Black;
    src: url('/fonts/AvenirLTStd-Black.otf') format('opentype');
    font-display: swap;
    font-weight: 900;
    font-style: normal;
  }

  @font-face {
    font-family: AvenirLTStd-Book;
    src: url('/fonts/AvenirLTStd-Book.otf') format('opentype');
    font-display: swap;
    font-weight: 400;
    font-style: normal;
  }

  @font-face {
    font-family: AvenirLTStd-Roman;
    src: url('/fonts/AvenirLTStd-Roman.otf') format('opentype');
    font-display: swap;
    font-weight: 500;
    font-style: normal;
  }

  html, body, #root {
    width: 100%;
    background:  ${({ theme }) => theme.colors.background};
    color:  ${({ theme }) => theme.colors.primary};
    height: 99%;
  }

  body, input, button, textarea {
    font-family: ${font};
    font-size: 14px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
  }

  body { -webkit-font-smoothing: antialiased; }

  a { text-decoration: none; }
  ul { list-style: none; }

  .Toastify__toast-container {
    z-index: 999999;
  }

  /* Tooltip container */
  .tooltip {
    position: relative;
    display: inline-block;
    border-bottom: 1px dotted black; /* If you want dots under the hoverable text */
  }

  /* Tooltip text */
  .tooltip .tooltiptext {
    visibility: hidden;
    width: 120px;
    background-color: #555;
    color: #fff;
    text-align: center;
    padding: 5px 0;
    border-radius: 6px;

    /* Position the tooltip text */
    position: absolute;
    z-index: 1;
    bottom: 125%;
    left: 50%;
    margin-left: -60px;

    /* Fade in tooltip */
    opacity: 0;
    transition: opacity 0.3s;
  }

  /* Tooltip arrow */
  .tooltip .tooltiptext::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #555 transparent transparent transparent;
  }

  /* Show the tooltip text when you mouse over the tooltip container */
  .tooltip:hover .tooltiptext {
    visibility: visible;
    opacity: 1;
  }

  /* Spinner animation */
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`
